export {default as quadtree} from "./src/quadtree";



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/d3-quadtree/index.js
// module id = ../../../../d3-quadtree/index.js
// module chunks = 3